module.exports = __webpack_public_path__ + "img/wok-met-curry.f30f43ef.jpg";